export default {
    DEFAULT: 'DEFAULT',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    LOADING: 'LOADING',
};
